import React from 'react';


const ForwardArrow = () => (
  <svg width="16" height="11" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.66667 0.166748L8.41667 1.41675L12.2253 5.22534H0.5V6.89201H12.2253L8.41667 10.7006L9.66667 11.9506L15.5586 6.05868L9.66667 0.166748Z" fill="#E80071" />
  </svg>
);

export default ForwardArrow;
